import { lighten, setLightness, darken, setSaturation } from 'polished';
import * as React from 'react';
//import ShareButtons from './ShareButtons';
import ImageInfo from './ImageInfo';
import Spinner from './ui/Spinner';
import styled from '@emotion/styled';
import rehypeReact from 'rehype-react';

import ReactCompareImage from 'react-compare-image';

import { colors } from '../styles/colors';

import LazyLoad from 'react-lazyload';

export const PostFullContent = styled.section`
  position: relative;
  margin: 0 auto;
  padding: 50px 100px 0;
  min-height: 230px;
  font-family: Barlow, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
    Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 2.5rem;
  line-height: 1.6em;
  border-radius: 2px;
  // background: rgba(255,255,255,0.2);

  @media (max-width: 1170px) {
    padding: 15px 7vw 0;
  }
  @media (max-width: 800px) {
    font-size: 1.9rem;
  }

  // :before {
  //   content: '';
  //   position: absolute;
  //   top: 15px;
  //   left: -5px;
  //   z-index: -1;
  //   display: block;
  //   width: 20px;
  //   height: 200px;
  //   background: rgba(39, 44, 49, 0.15);
  //   filter: blur(5px);
  //   transform: rotate(-5deg);
  // }

  // :after {
  //   content: '';
  //   position: absolute;
  //   top: 15px;
  //   right: -5px;
  //   z-index: -1;
  //   display: block;
  //   width: 20px;
  //   height: 200px;
  //   background: rgba(39, 44, 49, 0.15);
  //   filter: blur(5px);
  //   transform: rotate(5deg);
  // }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul,
  ol,
  dl,
  pre,
  blockquote,
  .post-full-comments,
  .footnotes {
    min-width: 100%;
  }

  li {
    word-break: break-word;
  }
  ul {
    list-style-type: none;
    padding-left: 1em;
  }

  .main-content ul li::before {
    background: ${colors.alpha};
    content: '';
    display: inline-block;
    height: 0.5em;
    top: -2px;
    left: -15px;
    position: relative;
    width: 0.5em;
    border-radius: 3px;
    transform: rotate(45deg);
    vertical-align: middle;
  }

  li p {
    margin: 0;
  }

  a {
    color: ${colors.alpha};
    word-break: break-word;
    text-decoration: #BDE5C7 1px underline;
    transition: all 0.25s;
  }

  a:hover {
    color: ${colors.alpha};
    text-decoration: ${colors.alpha} 1px underline;
  }

  strong,
  em {
    /* color: color(var(--omega) l(-5%)); */
    //color: ${darken('0.05', colors.omega)};
  }

  small {
    display: inline-block;
    line-height: 1.6em;
  }

  li:first-of-type {
    margin-top: 0;
  }

  video {
    display: block;
    margin: 1.5em auto;
    max-width: 1040px;
    height: auto;
  }
  .gatsby-resp-image-link {
    box-shadow: none;
  }
  img.img-comp-under,
  .img-comp-over {
    margin: 0 auto;
  }
  @media (max-width: 1040px) {
    img,
    video {
      width: 100%;
    }
  }

  img[src$='#full'] {
    max-width: none;
    width: 100vw;
  }

  img + br + small {
    display: block;
    margin-top: -3em;
    margin-bottom: 1.5em;
    text-align: center;
  }

  /* Override third party iframe styles */
  iframe {
    margin: 0 auto !important;
  }

  blockquote {
    margin: 0 0 1.5em;
    padding: 0 1.5em;
    border-left: #D7F2DE 3px solid;
  }

  blockquote p {
    margin: 0 0 1em 0;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    font-style: italic;
  }

  blockquote p:last-child {
    margin-bottom: 0;
  }

  code {
    padding: 0 5px 2px;
    font-size: 0.8em;
    line-height: 1em;
    font-weight: 400 !important;
    background: ${colors.whitegrey};
    border-radius: 3px;
  }

  p code {
    word-break: break-all;
  }

  pre {
    overflow-x: auto;
    margin: 1.5em 0 3em;
    padding: 20px;
    max-width: 100%;
    /* border: color(var(--omega) l(-10%)) 1px solid; */
    border:  colors.omega 1px solid;
    color: ${colors.whitegrey};
    font-size: 1.4rem;
    line-height: 1.5em;
    /* background: color(var(--omega) l(-3%)); */
    background: ${darken('0.03', colors.omega)};
    border-radius: 5px;
  }

  pre code {
    padding: 0;
    font-size: inherit;
    line-height: inherit;
    background: transparent;
  }

  pre code :not(span) {
    color: inherit;
  }

  /* .fluid-width-video-wrapper { */
  .gatsby-resp-iframe-wrapper {
    margin: 1.5em 0 3em;
  }

  hr {
    margin: 5rem 0;
  }

  // hr:after {
  //   content: '';
  //   position: absolute;
  //   top: -15px;
  //   left: 50%;
  //   display: block;
  //   margin-left: -10px;
  //   width: 1px;
  //   height: 30px;
  //   /* background: color(var(--lightgrey) l(+10%)); */
  //   background: #333;
  //   box-shadow: #fff 0 0 0 5px;
  //   transform: rotate(45deg);
  // }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${colors.omega};
    font-family: Barlow, sans-serif;
    text-decoration: none;
  }

  h1 {
    margin: 0.5em 0 0.2em 0;
    font-size: 4.6rem;
    font-weight: 700;
  }
  @media (max-width: 500px) {
    h1 {
      font-size: 2.8rem;
    }
  }

  h2 {
    margin: 0.75em 0 1em 0;
    font-size: 3.6rem;
    font-weight: 700;
  }
  
  h2:not(.text-center) {
    display: flex;
  }

  h2::after {
    content: " ";
    height: 3px;
    position: relative;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: auto;
    margin: .85em 2px 0 3px;
    flex-grow: 1;
    border-radius: 4px;
    background: linear-gradient(to right, ${setLightness('0.55', colors.beta)}, ${setLightness(
  '1',
  colors.beta,
)});
}
  @media (max-width: 500px) {
    h2 {
      font-size: 2.6rem;
    }
    h2::before {
      height: 1.8rem;
      width: 1.8rem;
    }
  }

  h3 {
    margin: 0.5em 0 0.75em 0;
    font-size: 2.8rem;
    font-weight: 700;
  }
  @media (max-width: 500px) {
    h3 {
      font-size: 2.2rem;
    }
  }

  h4 {
    margin: 0.5em 0 0.2em 0;
    font-size: 2.4rem;
    font-weight: 700;
    text-decoration: ${colors.whitegrey} underline;
  }
  @media (max-width: 500px) {
    h4 {
      font-size: 2.2rem;
    }
  }

  h5 {
    display: block;
    margin: 0.5em 0;
    padding: 1em 0 1.5em;
    border: 0;
    color: ${colors.alpha};
    font-size: 3.2rem;
    line-height: 1.35em;
    text-align: center;
  }
  @media (min-width: 1180px) {
    h5 {
      max-width: 1060px;
    }
  }
  @media (max-width: 500px) {
    h5 {
      padding: 0 0 0.5em;
      font-size: 2.2rem;
    }
  }

  h6 {
    margin: 0.5em 0 0.2em 0;
    font-size: 2rem;
    font-weight: 700;
  }
  @media (max-width: 500px) {
    h6 {
      font-size: 2rem;
    }
  }

  /* Tables */
  table {
    display: inline-block;
    overflow-x: auto;
    margin: 0.5em 0 2.5em;
    max-width: 100%;
    width: auto;
    border-spacing: 0;
    border-collapse: collapse;
    font-family: Barlow, sans-serif;
    font-size: 1.6rem;
    white-space: nowrap;
    vertical-align: top;
  }

  table {
    -webkit-overflow-scrolling: touch;
    background: radial-gradient(ellipse at left, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0) 75%) 0
        center,
      radial-gradient(ellipse at right, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0) 75%) 100% center;
    background-attachment: scroll, scroll;
    background-size: 10px 100%, 10px 100%;
    background-repeat: no-repeat;
  }

  table td:first-of-type {
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 20px 100%;
    background-repeat: no-repeat;
  }

  table td:last-child {
    background-image: linear-gradient(
      to left,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-position: 100% 0;
    background-size: 20px 100%;
    background-repeat: no-repeat;
  }

  table th {
    color: ${colors.omega};
    font-size: 1.2rem;
    font-weight: 700;
    letter-spacing: 0.2px;
    text-align: left;
    text-transform: uppercase;
    /* background-color: color(var(--whitegrey) l(+4%)); */
    background-color: ${lighten('0.04', colors.whitegrey)};
  }

  table th,
  table td {
    padding: 6px 12px;
    /* border: color(var(--whitegrey) l(-1%) s(-5%)) 1px solid; */
    border: ${setSaturation('0.05', darken('0.01', colors.whitegrey))} 1px solid;
  }

  @media (max-width: 500px) {
    padding: 0;
    :before {
      display: none;
    }
    :after {
      display: none;
    }
  }
`;

const SourceInfo = styled.p`
  text-align: center;
  margin-top: 1rem;
`;

const BeforeAfter = styled.p`
  color: ${colors.midgrey};
  text-transform: uppercase;
  text-align: center;
  font-size: 1.5rem;
  margin-bottom: 0.3rem;
  margin-top: 2.3rem;
`;

interface CompareWrapperProps {
  thin?: boolean;
}

const CompareWrapper = styled.div<CompareWrapperProps>`
  max-width: ${(props) => (props.thin ? '450px' : '100%')};
  margin: 0 auto;
`;

const renderAst = new rehypeReact({
  createElement: React.createElement,
  // components: { 'interactive-counter': Counter },
  components: {},
}).Compiler;

const Ast = ({ ast, ...props }: any) => {
  ast.properties = props;
  return renderAst(ast);
};

const LuminarVert = styled.img`
  display: none;

  @media (min-width: 1350px) {
    display: block;

    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }
`;

export interface PostContentProps {
  htmlAst: any;
  title: string;
  slug: string;
  imgSrc: string;
  intro: string;
  before: string;
  after: string;
  camera?: string;
  focal?: string;
  aperture?: string;
  shutter?: string;
  iso?: string;
  source?: string;
  thin?: boolean;
  photographer: {
    name?: string;
    url?: string;
  };
}

export interface PhotoSourceProps {
  source: string;
  photographer: {
    name?: string;
    url?: string;
  };
}

const PhotoSource: React.FunctionComponent<PhotoSourceProps> = ({ source, photographer }) => {
  return (
    <SourceInfo>
      <small>
        <a href={source} target="_blank" rel="noopener noreferrer">
          Photo
        </a>{' '}
        by{' '}
          {photographer.name}
        
        ,{' '}
        <a href="https://unsplash.com/license" target="_blank" rel="noopener noreferrer">
          free to use
        </a>
      </small>
    </SourceInfo>
  );
};

class RerenderCompare extends React.Component {
  t1;
  state = { delayOver: false };

  componentDidMount() {
    this.t1 = setTimeout(() => {
      this.setState({ delayOver: true });
    }, 800);
  }

  componentWillUnmount() {
    clearTimeout(this.t1);
  }

  render() {
    if (!this.state.delayOver) {
      return <Spinner />;
    }
    return this.props.children();
  }
}

const PostContent: React.FunctionComponent<PostContentProps> = ({
  htmlAst,
  title,
  slug,
  imgSrc,
  intro,
  before,
  after,
  camera,
  focal,
  aperture,
  shutter,
  iso,
  source,
  photographer,
  thin,
}) => {
  return (
    <PostFullContent className="post-full-content">
      {/*<ShareButtons title={title} slug={slug} imgSrc={imgSrc} >*/}
      {/* tslint:disable-next-line:react-no-dangerous-html */}
      <div className="intro" dangerouslySetInnerHTML={{ __html: intro }} />
      {before && after && <BeforeAfter>Before / After:</BeforeAfter>}
      {before && after && (
        <CompareWrapper thin={thin}>
          <RerenderCompare>
            {() => (
              <ReactCompareImage
                sliderPositionPercentage={0.33}
                leftImage={before}
                rightImage={after}
                sliderLineWidth={4}
                skeleton={<Spinner />}
              />
            )}
          </RerenderCompare>
        </CompareWrapper>
      )}
      {source && photographer && <PhotoSource source={source} photographer={photographer} />}
      {before && after && <hr />}
      {/* TODO: this will apply the class when rehype-react is published https://github.com/rhysd/rehype-react/pull/11 */}

      <div className="main-content">
        <Ast className="post-content" ast={htmlAst} />
      </div>
      {camera && aperture && shutter && iso && <BeforeAfter>🌄 Image info:</BeforeAfter>}

      {camera && aperture && shutter && iso && (
        <ImageInfo camera={camera} focal={focal} aperture={aperture} shutter={shutter} iso={iso} />
      )}
    </PostFullContent>
  );
};

export default PostContent;
